var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-class=\"[type ? 'alert-' + type : null]\" role=\"alert\" aria-live=\"assertive\" aria-atomic=\"true\" class=\"alert\"><button ng-if=\"dismissable\" type=\"button\" aria-label=\"Schließen\" ng-click=\"$hide()\" class=\"close\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-close\">&nbsp;</i></button><strong ng-bind=\"title\"></strong><div ng-bind-html=\"content\"></div></div>");;return buf.join("");
}